export const Auth0Domains = {
    'kashio-dev.auth0.com': 'https://kashio-dev.auth0.com',
    'kashio.auth0.com': 'https://kashio.auth0.com',
    'kashio-cert.auth0.com': 'https://kashio-cert.auth0.com'
}
